module.exports = __webpack_public_path__ + "img/2-increased.67a325ab.svg";